<template>
    <div>
        <div class="table-list table-list-persons d-flex flex-column mt-5">
                <div class="table-list-row table-head black_block">
                    <div class="table-list-persons__name d-flex align-items-center">
                        <div class="cb">
                            <input :checked="model_all" @change="checkAll" id="top" type="checkbox" class="custom_checkbox">
                            <label for="top"></label>
                        </div>
                        <span @click="sortName" class="cursor_pointer">
                            <iconsort :updown="sort_name"></iconsort>
                            <span>Name</span>
                        </span>
                    </div>                    
                    
                    
                    <div>
                        <span @click="sortPerson" class="cursor_pointer">
                            <iconsort :updown="sort_person"></iconsort>
                            <span>Person ID</span>
                        </span>
                    </div>
                    
                    
                    
                    <div class="table-list-row__rcgnz_num">
                        <span @click="sortDefs" class="cursor_pointer">
                            <iconsort :updown="sort_defs"></iconsort>
                            <span>Defs</span>
                        </span>
                    </div>
                    
                    
                    
                    <div class="table-list-row__description">Description</div>                    
                    <div class="text-center"></div>
                </div>
                <div v-for="(person, key) in personsItem" :key="'pers_'+person.id" class="table-list-row black_block p-0">
                    <div class="">
                        <div class="avatar_and_title d-flex justify-content-start">
                            <div class="img-avatar"
                                v-bind:style="{ 'background-image': `url(${person.avatar_url || (base_url + '/' + person.id + '.jpg')})` }">
                            </div>
                            <div class="cb">                            
                                <input v-model="person.checked" @change="changeItem" :id="`t_${key}`" type="checkbox" class="custom_checkbox">
                                <label :for="`t_${key}`">{{person.first_name}} {{person.last_name}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="table-list-persons__id" :title="person.uuid || ''">{{ person.uuid || person.id }}</div>
                    
                    
                    
                    <div class="hists_num">{{person.histories_count != null ? person.histories_count : (person.histories ? person.histories.length : 0)}}</div>
                    
                    
                    
                    <div class="table-list-row__description">{{person.info}}</div>
                    <div class="text-center d-flex justify-content-between mr-5 table-list-row__action">
                        <a :href="`/categories/${person.categories[0].id}/persons/${person.id}`" class="btn btn-border btn-sm table-list-row__action">VIEW PROFILE</a>
                        <div class="dotscontrol">
                            <div class="dotscontrol_dots" type="button" :id="`dropdownMenuButton${key}`" data-bs-toggle="dropdown" aria-expanded="false">
                                <span class="dotscontrol_dots__span"></span>
                            </div>
                            <ul class="dropdown-menu" :aria-labelledby="`dropdownMenuButton${key}`">
                                <li><a @click="editPerson(person)" class="dropdown-item" href="#">EDIT</a></li>
                                <li><a @click="deletePerson(person.id)" class="dropdown-item" >DELETE</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <pagin  align="center" :data="data" @pagination-change-page="getPersons">
                <span slot="prev-nav">
                    <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.91456 0.958033L2.00028 7.04255L8.0848 12.9568" stroke="white" stroke-width="2"/>
                    </svg>
                </span>
                <span slot="next-nav">
                    <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.999999 13L7 7L0.999999 1" stroke="white" stroke-width="2"/>
                    </svg>
                </span>
            </pagin>
        </div>
</template>

<script>
import {bus} from '../../bus';
import axios from 'axios';
import Pagin from 'laravel-vue-pagination';
import Dotscontrol from '../Dotscontrol';
import iconsort from "../iconsort";

export default{
    props: [
        "model_find_prop",        
        "category_id_prop"
    ],
    data(){
        return{
            data: {},
            persons: [],
            sort: 'first_name',
            sorttype: 'asc',
            sort_name: 'up',
            sort_date: 'up',
            sort_size: 'up',
            sort_status: 'up',
            sort_person: 'up',
            sort_defs: 'up',
            model_all: false,
            model_counitempage: 10,
            model_find: '',
            listdelete: [],
            personsIds: [],
            symbolsDescrNumLimit: 200,            
            category_id: null,
            // Ignore stale list responses that finish after a newer fetch.
            fetchSeq: 0,
            // Collapse burst getListPerson emits (bulk delete fires one per id).
            getListPersonTimer: null
        }
    },
    methods: {
        deletePerson(id){
            // alert(id);
            axios.delete('/persons/'+id).then((responce) => {
                console.log(responce);
                //this.getPersons();
                bus.$emit('getListPerson');
            }).catch((error) => {
                console.log('error delete person', error);
            });
        },   
        editPerson(person){
            console.log(person);
            bus.$emit('openpopup', {
                'open': true,
                'type': 'formperson',
                'crud': 'update',
                'title_form': 'Update person',
                'category_id': Number(this.category_id),
                'person': person
            });
        },
        personKey(person){
            if (!person) {
                return null;
            }
            if (person.uuid) {
                return String(person.uuid);
            }
            if (person.id !== undefined && person.id !== null) {
                return String(person.id);
            }
            return null;
        },
        snapshotCheckedKeys(){
            const checked = {};
            (this.persons || []).forEach((item) => {
                if (!item || !item.checked) {
                    return;
                }
                const key = this.personKey(item);
                if (key) {
                    checked[key] = true;
                }
                // Also index by id when uuid was the primary key.
                if (item.id !== undefined && item.id !== null) {
                    checked[String(item.id)] = true;
                }
            });
            return checked;
        },
        syncSelection(){
            this.listdelete = [];
            this.personsIds = [];
            this.persons.forEach((item) => {
                if (item.checked) {
                    this.listdelete.push(item.id);
                    this.personsIds.push(item.id);
                }
            });
            this.model_all = this.persons.length > 0
                && this.persons.every((item) => item.checked);
            bus.$emit('changeSelectPersons', {
                'listdelete': this.listdelete,
                'personsIds': this.personsIds
            });
        },
        changeItem(){
            this.syncSelection();
        },
        checkAll(event){
            // Prefer the native checkbox state; avoid v-model + @change races.
            const checked = event && event.target
                ? !!event.target.checked
                : !!this.model_all;
            this.model_all = checked;
            this.persons.forEach((item) => {
                this.$set(item, 'checked', checked);
            });
            this.syncSelection();
        },
        preparePersons(persons, checkedByKey){
            const checkedMap = checkedByKey || {};
            return (persons || []).map((person) => {
                const key = this.personKey(person);
                const idKey = person && person.id !== undefined && person.id !== null
                    ? String(person.id)
                    : null;
                const stillChecked = !!(
                    (key && checkedMap[key])
                    || (idKey && checkedMap[idKey])
                );
                const prepared = Object.assign({}, person, { checked: stillChecked });
                if (
                    prepared.info !== null
                    && prepared.info !== undefined
                    && prepared.info.length > this.symbolsDescrNumLimit
                ) {
                    prepared.info = prepared.info.substring(0, this.symbolsDescrNumLimit) + '...';
                }
                return prepared;
            });
        },
        scheduleGetPersons(page){
            if (this.getListPersonTimer) {
                clearTimeout(this.getListPersonTimer);
            }
            this.getListPersonTimer = setTimeout(() => {
                this.getListPersonTimer = null;
                this.getPersons(page);
            }, 250);
        },
        getPersons(page = 1){            
            this.model_find = this.model_find ? this.model_find : this.model_find_prop;
            const url = `/persons`;
            let params = {
                page: page,
                countitempage: this.model_counitempage,                
                sort: this.sort,                
                sorttype: this.sorttype,
                category_id: this.category_id,
                name: this.model_find
            };
            const seq = ++this.fetchSeq;
            // Snapshot at request time AND again on response so a select-all
            // clicked while the request is in flight is not wiped by late refresh.
            const checkedAtRequest = this.snapshotCheckedKeys();
            // params.page = this.page;
            axios.get(
                url,            
                {
                    params: params,
                    headers: {
                        'ContentType': 'application/json'
                    }
                }                
            )           
            .then((response) => {
                if (seq !== this.fetchSeq) {
                    // Newer fetch already started — drop this stale payload.
                    return;
                }
                // handle success
                console.log('persons', response);
                const checkedNow = this.snapshotCheckedKeys();
                const checkedByKey = Object.assign({}, checkedAtRequest, checkedNow);
                this.data = response.data;
                this.persons = this.preparePersons(response.data.data, checkedByKey);
                // Recompute header / bulk lists from preserved row checks.
                // Do NOT force-clear — that raced with post-delete select-all.
                this.syncSelection();
            })
            .catch( (error) => {
                // handle error
                console.log(error);
            })
        },
        sortName(){
            this.sort = 'first_name';
            if(this.sort_name === 'up'){
                this.sort_name = 'down';
                this.sorttype = 'desc';
            }else{
                this.sort_name = 'up';
                this.sorttype = 'asc';
            }
            this.getPersons();
        },
        sortPerson(){
            this.sort = 'id';
            if(this.sort_person === 'up'){
                this.sort_person = 'down';
                this.sorttype = 'desc';
            }else{
                this.sort_person = 'up';
                this.sorttype = 'asc';
            }
            this.getPersons();
        },
        sortDefs(){
            this.sort = 'histories_count';
            if(this.sort_defs === 'up'){
                this.sort_defs = 'down';
                this.sorttype = 'desc';
            }else{
                this.sort_defs = 'up';
                this.sorttype = 'asc';
            }
            this.getPersons();
        },        
    },
    mounted(){
        this.category_id = this.category_id_prop;
        // Build marker: if DevTools does not show this, the browser is on a stale app.js.
        console.info('[PersonsList] select-all fix 2026-09-24 (preserve checked across refresh)');
        console.log('this.category_id: ', this.category_id);
        this.getPersons();
        // Single listener only — duplicate handlers double-fetched and cleared selection.
        // Debounce: bulk delete emits getListPerson once per id; collapsing avoids
        // a storm of refetches that race with the next select-all click.
        bus.$on('getListPerson', () => {
            console.log('getListPerson handler fire');
            const page = (this.data && this.data.current_page) ? this.data.current_page : 1;
            this.scheduleGetPersons(page);
        });
        this.model_find = this.model_find_prop;
        bus.$on('changeModelAll', (data) => {
            if(data){
                this.model_all = data.model_all;
            }
        })
    },
    beforeDestroy(){
        if (this.getListPersonTimer) {
            clearTimeout(this.getListPersonTimer);
            this.getListPersonTimer = null;
        }
    },
    computed: {
        // Passthrough only — never reset checked here (that broke select-all sync).
        personsItem(){
            return this.persons;
        },
        base_url() {
           return this.$store.state.base_url;
        }

    },
    watch: { 
      	model_find_prop: function(new_model_find_prop, old_model_find_prop) { // watch it
          console.log('Prop changed: ', new_model_find_prop, ' | was: ', old_model_find_prop)
          this.model_find = new_model_find_prop;
        }
    },
    components: {
        Pagin,
        Dotscontrol,
        iconsort
    }
}
</script>
<style scoped>
    .pagination {
     flex-wrap: wrap;   
    }
    
    .table-list .table-list-row {
        grid-template-columns: 4fr minmax(240px, 2.2fr) 50px 2.5fr 205px;
    }
    .table-list-persons__id {
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 0.78rem;
        word-break: break-all;
        padding-right: 8px;
    }
    .table-list-row__description {
        padding: 0 5px;
    }
</style>